module.exports = __webpack_public_path__ + "img/2024nh1.405ef9dd.jpg";